module.exports = __webpack_public_path__ + "static/media/netflix-logo.00333b1b.svg";